import { render } from "./YearCard.vue?vue&type=template&id=4f62d480&scoped=true"
import script from "./YearCard.vue?vue&type=script&lang=js"
export * from "./YearCard.vue?vue&type=script&lang=js"

import "./YearCard.vue?vue&type=style&index=0&id=4f62d480&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f62d480"]])

export default __exports__